import AboutDesktopTabletSectionLayout from "../../layouts/aboutScreen/AboutDesktopTabletSectionLayout";
import AboutDesktopTabletTopTitleLayout from "../../layouts/aboutScreen/AboutDesktopTabletTopTitleLayout";
import AboutContactText from "../../texts/aboutScreen/AboutContactText";
import {kAboutScreenImages} from "../../../constants/images";

export default function AboutContactSection() {
    // Used in AboutContent to display
    // contact section in desktop tablet modes

    // BUILD
    return (
        <AboutDesktopTabletSectionLayout>
            <AboutDesktopTabletTopTitleLayout>
                <div className={"w-full flex justify-start items-start space-x-[32px]"}>
                    <div className={`h-[200px] min-h-[200px] w-[120px] min-w-[120px] flex justify-center items-center`}>
                        <img className={"object-contain h-full"}
                             src={kAboutScreenImages.letterFox}
                             alt="Courrier" />
                    </div>
                    <AboutContactText />
                </div>
            </AboutDesktopTabletTopTitleLayout>
        </AboutDesktopTabletSectionLayout>
    );
}